<template lang="pug">
  Popup(:visible="visible" :showMask="!isCollecting")
    .exchange-goods-card-container(
      :class="{ 'hide-bg': isCollecting }"
      v-scroll-lock="visible"
    )
      Lottie.lottie(
        v-if="!isCollecting"
        key="bcg_lottie",
        url="https://m.hellobike.com/resource/gallery/43/tFE92QRL_data.json"
      )
      .exchange-goods-content(:class="{ 'animate-collect': isCollecting }")
        img.title(:src="goodsInfo.goodsImageUrl" alt="")
        img.logo(:src="goodsInfo.logo" alt="")
        .btn(@click="handleBtnClick") 收下
        .btn-tips(v-if="!isCollecting")
          CountDown(:duration="3" displayMode="slot" @finish="handleCountDownFinished")
            template(#default="{ time, formatted }")
              .count-down-text {{ time.total }}s后自动收下
</template>

<script>
import { CountDown } from '@hb/platformui-h5';
import Popup from '@/components/popup';
import Lottie from '@/components/lottie';
import SPM from '../common/spm';
import NextButton from './next-button';

export default {
  name: 'GoodsPopup',
  components: {
    NextButton,
    Lottie,
    Popup,
    CountDown,
  },
  props: {
    // 是否展示
    visible: {
      type: Boolean,
      default: false,
    },
    // 商品信息
    goodsInfo: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      // 是否正在收起
      isCollecting: false,
      // 收起动画定时器
      timer: null,
    };
  },
  watch: {
    visible(newVal) {
      if (!newVal) {
        // 重置动画
        this.isCollecting = false;
        if (this.timer) {
          clearTimeout(this.timer);
        }
      } else {
        // 商品卡片模块曝光埋点
        SPM.moduleExpose({
          moduleId: 'newcus_first',
          contentId: 'newcus_first',
          businessInfo: {},
        });
      }
    },
  },
  mounted() {},
  beforeDestroy() {
    if (this.timer) {
      clearTimeout(this.timer);
    }
  },
  methods: {
    collectGoods() {
      this.isCollecting = true;
      this.$emit('btnClick');
      this.timer = setTimeout(() => {
        this.$emit('nextClick');
      }, 1000);
    },
    // 按钮点击
    handleBtnClick() {
      this.collectGoods();
      // 商品卡片模块点击埋点（收下按钮点击）
      SPM.clickButton({
        buttonName: 'newcus_first',
        businessInfo: {},
      });
    },
    // 倒计时结束
    handleCountDownFinished() {
      this.collectGoods();
    },
  },
};
</script>

<style lang="less" scoped>
.exchange-goods-card-container {
  position: relative;
  width: 100vw;
  height: 100vh;
  background-image: url('https://m.hellobike.com/resource/gallery/833/NaEWNzHy_Rectangle%20346242300.png');
  background-size: 100% 3.2rem;
  background-repeat: no-repeat;

  &.hide-bg {
    background-image: none;
  }

  .exchange-goods-lottie {
    width: 100%;
    height: 100%;
  }

  .exchange-goods-content {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    flex-direction: column;
    align-items: center;

    .title {
      margin-bottom: 0.24rem;
      width: 1.78rem;
      height: 0.45rem;
      vertical-align: bottom;
      opacity: 1;
      transition: opacity 0.3s ease-in-out;
    }

    .logo {
      width: 2.6rem;
      height: auto;
      vertical-align: bottom;
      margin-bottom: 0.5rem;
      opacity: 1;
      transition: opacity 0.3s ease-in-out;
    }

    .btn {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 1.12rem;
      height: 0.38rem;
      background-image: url('https://m.hellobike.com/resource/gallery/833/8RecVW74_Rectangle%203473826.png');
      background-size: 100% 100%;
      background-repeat: no-repeat;
      font-weight: 600;
      font-size: 0.18rem;
      line-height: normal;
      color: #fff;
    }

    &.animate-collect {
      animation: forwards 1s collect;

      .title,
      .btn {
        opacity: 0;
      }
    }

    @keyframes collect {
      0% {
        transform: translate(-50%, -50%) scale(1) rotate(0deg);
        opacity: 1;
      }

      100% {
        transform: translate(-2.6rem, -3.5rem) scale(0.2) rotate(-10deg);
        opacity: 0;
      }
    }

    .btn-tips {
      margin-top: 0.15rem;

      .count-down-text {
        font-size: 0.14rem;
        color: rgba(255, 255, 255, 0.9);
        line-height: 0.2rem;
      }
    }
  }
}
</style>
